"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_dev_1 = require("./is-dev");
var documentPolyfill = {
    getElementById: function () { return ({}); }
};
exports.default = is_dev_1.isDevEnv() ? documentPolyfill : window.document || documentPolyfill;
